import React, { useState, useEffect, useRef } from 'react';
import { Carousel } from "antd";
import { imageUrl, zeusApp } from '../request/index';
import { useCustomData } from '../pages/context/indexCustomDataContext';
import bannerImage from '../assets/image/bannerImage.png'

const PomeloSwiper: React.FC = () => {
    const { getValue } = useCustomData();
    const homeBanner = getValue('homeBanner'); // "id1,id2,id3"

    const [imageIds, setImageIds] = useState<string[]>([]);
    const [videoLoaded, setVideoLoaded] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if (homeBanner) {
            const ids = homeBanner.split(',').map((id: string) => id.trim());
            setImageIds(ids);
        }
    }, [homeBanner]);

    // 视频加载完成的处理函数
    const handleVideoLoaded = () => {
        setVideoLoaded(true);
    };

    // 视频加载错误的处理函数
    const handleVideoError = () => {
        console.error('视频加载失败');
        // 即使视频加载失败，也设置加载完成状态，避免一直显示背景图
        setVideoLoaded(true);
    };

    const contentStyle: React.CSSProperties = {
        margin: 0,
        height: '603px',
        color: '#fff',
        lineHeight: '603px',
        textAlign: 'center',
        // background: '#ac9455',
        position: 'relative',
    };

    return (
        <div>
            <span 
                className='videoBox' 
                style={{
                    backgroundImage: videoLoaded ? 'none' : (bannerImage ? `url(${bannerImage})` : 'none'),
                    backgroundSize:'cover'
                }}
            >
                <div className='videoText' style={{top:'260px',left:'922px'}}>立足上海，服务世界</div>
                <div className='videoText' style={{top:'320px',left:'730px', fontSize:'25px',marginTop:'3px'}}>Based in Shanghai，Serving the world.</div>
            </span>
            <div className="pomelo-swiper">
                <Carousel autoplay>
                    {imageIds.map((id, index) => (
                        <div key={index}>
                            <div style={contentStyle}>
                                <video
                                    ref={videoRef}
                                    src={`${imageUrl}B183A235B5F6491682FD4B6849CF6368?zeus-app=${zeusApp}`}
                                    autoPlay 
                                    loop 
                                    muted 
                                    playsInline
                                    onLoadedData={handleVideoLoaded}
                                    onCanPlay={handleVideoLoaded}
                                    onError={handleVideoError}
                                    style={{
                                        opacity: videoLoaded ? 1 : 0, // 视频加载完成后显示
                                        transition: 'opacity 0.5s ease-in-out'
                                    }}
                                />
                                {/* 视频加载时的遮罩层 */}
                                {!videoLoaded && (
                                    <div 
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontSize: '18px'
                                        }}
                                    >
                                        视频加载中...
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>
        </div>
    );
};

export default PomeloSwiper;